<ng-template>
  @if (icon(); as icon) {
    <i class="bwi !tw-me-2" [class]="icon" aria-hidden="true"></i>
  }
  <ng-content></ng-content>
</ng-template>
